import { Box, Button } from "@mui/material";
import StudyConnectorsForm from "./StudyConnectorsForm";
import PrimarySystemForm from "./PrimarySystemForm";
import SecondarySystemForm from "./SecondarySystemForm";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { connectorSchemaAPI, connectorSchemaSFTP } from "./connectorSchema";
import { useEffect, useState } from "react";
import Loader from "../common/Loader/Loader";
import { useSnackbar } from "../../hooks/useSnackbar";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { useConnector } from "./useConnector";
import { AppState, useAppSelector } from "../../store";

const AddConnector = () => {
  const { showSuccess } = useSnackbar();
  const [priMode, setPriMode] = useState("SFTP");
  const params = useParams();
  const connectorData = useAppSelector(
    (state: AppState) => state.commonSlice.connetorDetails
  );
  const isView: any = params?.connector_id;
  const [isDisable, setIsDisable] = useState(false);
  const connectorSchema =
    priMode === "SFTP" ? connectorSchemaSFTP : connectorSchemaAPI;
  const values =
    isView?.length > 0
      ? connectorData
      : { mode: "SFTP", secondary_mode: "SFTP" };
  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    watch,
    setValue,
  } = useForm({
    resolver: zodResolver(connectorSchema),
    defaultValues: values,
  });

  const { createConnector, createConnectorData, createConnectorIsSuccess } =
    useConnector();

  const onSubmit = (data: any) => {
    const primaryConditionalPayload =
      data.mode === "API"
        ? {
            base_api_path: data?.base_api_path,
            token_url: data?.token_url,
            study_json_path: data?.study_json_path,
          }
        : {
            base_folder_path: data?.base_folder_path,
            sftp_host: data?.sftp_host,
            sftp_port: data?.sftp_port,
          };
    const secondaryConditionalPayload =
      data.secondary_mode === "API"
        ? {
            base_api_path: data?.secondary_base_api_path,
            token_url: data?.secondary_token_url,
            study_json_path: data?.secondary_study_json_path,
          }
        : {
            base_folder_path: data?.secondary_base_folder_path,
            sftp_host: data?.secondary_sftp_host,
            sftp_port: data?.secondary_sftp_port,
          };
    const temp = {
      connections: [
        {
          connector_id: data.connector_id,
          name: data.name,
          study_ids: data.study_ids,
          primary: {
            type: "primary",
            mode: data.mode,
            data_format: data.data_format,
            base_url: data.base_url,
            username: data.username,
            password: data.password,
            study_file_id: data.study_file_id,
            study_xpath: data.study_xpath,
            mapping_id: data.mapping_id,
            ...primaryConditionalPayload,
          },
          secondary: {
            type: "secondary",
            mode: data.secondary_mode,
            data_format: data.secondary_data_format,
            base_url: data.secondary_base_url,
            username: data.secondary_username,
            password: data.secondary_password,
            study_file_id: data.secondary_study_file_id,
            study_xpath: data.secondary_study_xpath,
            mapping_id: data.secondary_mapping_id,
            ...secondaryConditionalPayload,
          },
        },
      ],
    };
    createConnector({ data: temp });
  };

  const onInvalid = (data: any) => {
    console.debug(data);
  };

  useEffect(() => {
    if (createConnectorIsSuccess) {
      setIsDisable(true);
      showSuccess(createConnectorData?.details, "create-connector-success");
    }
  }, [createConnectorIsSuccess]);

  const navigate = useNavigate();

  return (
    <>
      <Loader />
      <Box className="backBtnWrap">
        <Button
          startIcon={<ArrowBackIosNewRoundedIcon fontSize="small" />}
          size="small"
          onClick={() => navigate("/configuration/connectors")}
          id="connecctor-back"
        >
          Back
        </Button>
      </Box>
      <fieldset
        disabled={isView?.length > 0 || isDisable}
        style={{ margin: 0, padding: 0, border: 0 }}
      >
        <form onSubmit={handleSubmit(onSubmit, onInvalid)}>
          <StudyConnectorsForm
            control={control}
            register={register}
            errors={errors}
          />
          <PrimarySystemForm
            control={control}
            register={register}
            errors={errors}
            watch={watch}
            setValue={setValue}
            setPriMode={setPriMode}
            isView={isView}
          />
          <SecondarySystemForm
            control={control}
            register={register}
            errors={errors}
            watch={watch}
            setValue={setValue}
            isView={isView}
          />

          <Box className="footerStickyBtnWrap dFlex justifyContentEnd">
            <Button type="submit" variant="contained" id="save-connector">
              Save
            </Button>
          </Box>
        </form>
      </fieldset>
    </>
  );
};

export default AddConnector;
